enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  VERIFY_AUTH_USER = "verifyAuthUser",
  VERIFY_AUTH_BANK = "verifyAuthBank",
  VERIFY_AUTH_SEKOLAH = "verifyAuthSekolah",
  VERIFY_AUTH_SISWA = "verifyAuthSiswa",
  VERIFY_AUTH_FINANCE = "verifyAuthFinance",
  // VERIFY_AUTH_INVOICE = "VerifyAuthInvoice",
  VERIFY_AUTH_NOTIFIKASI = "VerifyAuthNotifikasi",
  LOGIN = "login",
  LOGOUT = "logout",
  SHOW_LOGIN = "show_login",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  //-------------------
  GET_SEKOLAH = "getSekolah",
  NOTIFIKASI = "getNotif",
  CEK_INITIAL= "cekInitial",
  CEK_COMPANY = 'cekCompany',
  SEND_ADDRESS= "sendAddress",

  SET_NEWS_ACTION = "setNewsAction",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_ADDRESS = "setAddress",
  SET_NOTIF = "setNotif",
  SET_PASSWORD = "setPassword",
  SET_INITIAL = "setInitial",
  SET_ERROR = "setError",
  SET_SHOWLOGIN = "setShowLogin",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_SEKOLAH = "setSekolah",
  CHANGE_TAB = "changeTab",
  SET_NEWS_MUTATION = "setNewsMutation",
}

export { Actions, Mutations };
